import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import BottomSheet from '@/components/molecules/BottomSheet';
import theme from '@/styles/theme';
import { Client } from '@/types/app';
import { cn } from '@/utils/style';
import { Button } from 'doctornow-design-system';
import { QRCodeCanvas } from 'qrcode.react';

interface Props {
  buttonId?: string;
  treatmentMedicineId?: string;
  qrCodeUrl: string;
  invitationCode?: string;
  client: Client;
  treatmentProductMedicineName: string;
  onClose: () => void;
  onClickOpenAppInstallLink: () => void;
  onClickCopyInvitationCode: () => void;
}
const DiagnosisAppInstallBottomSheet = ({
  buttonId,
  treatmentMedicineId = '0',
  qrCodeUrl,
  invitationCode,
  treatmentProductMedicineName,
  onClose,
  client,
  onClickOpenAppInstallLink,
  onClickCopyInvitationCode,
}: Props) => {
  return (
    <BottomSheet isOpened={true} onClickOverlay={onClose} index={20}>
      <div className={cn('flex flex-col gap-[24px] p-[24px_20px_32px]', client.isMobile && 'gap-[20px]')}>
        {client.isMobile ? (
          <>
            <div className={'typography-ui-22sb whitespace-pre-line text-gray-900'}>
              닥터나우 앱을 설치하고{'\n'}
              {treatmentProductMedicineName} 처방 저렴하게 받으세요!
            </div>
            <img
              className={'h-[144px] object-contain'}
              src={'https://doctornow-front-images.s3.ap-northeast-2.amazonaws.com/non_benefit_invitation.png'}
              alt='계산서 이미지'
            />
          </>
        ) : (
          <>
            <div className={'typography-ui-22sb whitespace-pre-line text-gray-900'}>
              QR코드를 스캔해 앱을 설치하고{'\n'}
              {treatmentProductMedicineName} 처방 저렴하게 받으세요!
            </div>
            <QRCodeWrapper>
              <QRCodeCanvas value={qrCodeUrl} size={120} />
            </QRCodeWrapper>
          </>
        )}

        <div className={'flex flex-col gap-[12px]'}>
          <div className={'flex flex-col items-center gap-[8px] rounded-[8px] bg-gray-20 py-[24px]'}>
            <span className={'typography-ui-15m text-gray-500'}>추천 코드</span>
            <div className={'flex items-center gap-[8px]'}>
              <span className={'typography-ui-20sb text-gray-900'}>{invitationCode}</span>
              <button onClick={onClickCopyInvitationCode}>
                <MaterialIcon name={'file_copy'} filled size={16} color={theme.color.gray300} />
              </button>
            </div>
          </div>
          <span className={'typography-ui-15r text-center text-gray-600'}>가입 시 추천 코드를 입력해주세요.</span>
        </div>
        {client.isMobile && (
          <Button
            id={buttonId ? buttonId : `selected-medicine-${treatmentMedicineId}`}
            className={'mt-[40px] w-full'}
            size={'xl'}
            onClick={onClickOpenAppInstallLink}
          >
            앱에서 최저가 확인하기
          </Button>
        )}
      </div>
    </BottomSheet>
  );
};

export default DiagnosisAppInstallBottomSheet;

const QRCodeWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 24px;
  margin-bottom: 8px;
`;
